export default __webpack_public_path__ + "static/media/GameDevelopmentBanner.2754c9e3.jpg";